import { AppHTTPService } from '../http-service'

export const updateSpaces = async (params: {
  appId?: string
  environmentId: string
  spaceIds: string[]
  archive?: boolean
}): Promise<any> => {
  if (params.archive === true) {
    const archiveSpace = (spaceId: string) => {
      AppHTTPService.axios.post(`/v1/spaces/${spaceId}/archive`)
    }
    return Promise.all(params.spaceIds.map(async (spaceId) => archiveSpace(spaceId)))
  }
  //todo: after new version of api is cut, use the unarchive endpoint instead
  const updateSpace = (spaceId: string, appId?: string, archive?: boolean) =>
    AppHTTPService.axios.patch(`/v1/spaces/${spaceId}`, {
      ...(appId ? { appId } : {}),
      ...(archive === false ? { archivedAt: null } : {}),
    })
  return Promise.all(params.spaceIds.map(async (spaceId) => updateSpace(spaceId, params.appId, params.archive)))
}
